import { rectangularmicroqrcode } from '@bwip-js/browser';

// One cached payload: editor moves/resizes must not encode the same URL repeatedly.
let cached: { text: string; canvas: HTMLCanvasElement } | undefined;
export function rectangularQr(text: string): HTMLCanvasElement {
  if (cached?.text === text) return cached.canvas;
  // Prefer a compact rectangle; grow only when the payload requires it.
  for (const version of ['R17x59', 'R13x77', 'R17x77', 'R17x99', 'R17x139']) {
    const canvas = document.createElement('canvas');
    try {
      const options = { bcid: 'rectangularmicroqrcode', text, version, eclevel: 'M', scale: 1, padding: 4, backgroundcolor: 'FFFFFF' };
      rectangularmicroqrcode(canvas, options);
      // BWIPP's rMQR uses 2 pixels/module at scale 1. Normalize to one
      // pixel/module, including the two-module quiet zone on every side.
      const normalized = document.createElement('canvas');
      const [, rows, columns] = /^R(\d+)x(\d+)$/.exec(version)!;
      normalized.width = Number(columns) + 4;
      normalized.height = Number(rows) + 4;
      const context = normalized.getContext('2d');
      if (!context) throw new Error('Canvas non disponibile');
      context.imageSmoothingEnabled = false;
      context.drawImage(canvas, 0, 0, normalized.width, normalized.height);
      cached = { text, canvas: normalized };
      return normalized;
    } catch (error) {
      if (!String(error).includes('Maximum length exceeded')) throw error;
    }
  }
  throw new Error('Il collegamento è troppo lungo per rMQR. Seleziona QR standard.');
}
